module.exports = __webpack_public_path__ + "static/media/main idea.3a5025d9.mp3";